import $ from "jquery"

export function setupContactForm() {
  var lang = $("#lang").val()

  var el = $(".contact-form")
  var form = el.find("form")
  var errors = form.find(".errors")
  var success = form.find(".success")
  var submitBtn = form.find(".btn-primary")
  var submitBtnDisabledText = submitBtn.data("text-disabled")
  var submitBtnText = submitBtn.data("text")

  function disableSubmit() {
    submitBtn.attr("disabled", "disabled").html(submitBtnDisabledText)
  }

  function enableSubmit() {
    submitBtn.removeAttr("disabled").html(submitBtnText)
  }
  function successMessage() {
    if (lang === "pl") {
      return "Dziękujemy za przesłanie formularza"
    }
    if (lang === "en") {
      return "Thank you for sending the form"
    }
    if (lang === "ru") {
      return "Благодарим за отправку формы"
    }
    return "Ok"
  }
  function resetForm() {
    $("#name").val("")
    $("#firm").val("")
    $("#email").val("")
    $("#phone").val("")
    $("#body").val("")
  }

  function showSuccess() {
    success.html("<p>" + successMessage() + "</p>").slideDown()
  }

  function onSuccess(data) {
    resetForm()
    showSuccess()
    enableSubmit()
  }
  function errorMessage(key, lang) {
    var data = {
      "name.required": {
        pl: "Imię i nazwisko jest wymagane",
        en: "Firstname and surname is required",
        ru: "Требуется имя и фамилия"
      },
      "email.required": {
        pl: "E-mail jest wymagany",
        en: "E-mail is required",
        ru: "Требуется электронная почта"
      },
      "email.email": {
        pl: "E-mail nie jest prawidłowy",
        en: "E-mail is not valid",
        ru: "Неправильный адрес электронной почты"
      },
      "body.required": {
        pl: "Treść wiadomości jest wymagana",
        en: "Message is required",
        ru: "Требуется содержание сообщения"
      }
    }
    if (data.hasOwnProperty(key) && data[key].hasOwnProperty(lang)) {
      return data[key][lang]
    }
    return "missing-translation:" + key
  }

  function onError(res) {
    function errorsContent(d, lang) {
      var html = "<ul>"
      $.each(d, function(key) {
        html += "<li>" + errorMessage(d[key][0], lang) + "</li>"
      })
      html += "</ul>"
      return html
    }
    if (res.status === 422) {
      var content = errorsContent(res.responseJSON, lang)
      errors.html(content).slideDown()
      success.slideUp()
    } else {
      errors.slideUp()
    }
    enableSubmit()
  }

  function onSubmit(e) {
    e.preventDefault()
    errors.html("").slideUp()
    success.html("").slideUp()

    var formData = new FormData()
    formData.append("lang", $("#lang").val())
    formData.append("name", $("#name").val())
    formData.append("firm", $("#firm").val())
    formData.append("email", $("#email").val())
    formData.append("phone", $("#phone").val())
    formData.append("body", $("#body").val())
    // var fileData = $("#file")[0].files;
    // formData.append("file", fileData[0]);

    disableSubmit()
    $.ajax({
      url: "/forms-module/contact-form",
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      method: "POST",
      type: "POST", // For jQuery < 1.9
      success: onSuccess,
      error: onError
    })
  }
  if (form) {
    form.on("submit", onSubmit)
  }
}
